export default __webpack_public_path__ + "static/EuclidFlex-Regular-WebXL-60b7a2a819b79bdb090a1604f1eaa2f3.woff2";